module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"start":"Start from","end":"Expire after","table_actions":"Actions"},"ua":{"start":"Діє з","end":"Не діє після","table_actions":"Дії"},"ru":{"start":"Действует с","end":"Не действует послуе","table_actions":"Действия"}}')
  delete Component.options._Ctor
}
